import WarpElement from "@warp-ds/elements-core";
import { PopularSearchLink } from "../../models/seoData.js";
import { css, html } from "lit";
import { i18n } from "@lingui/core";
import { activateI18n } from "../../utils/i18n.js";

class PopularLinksForSeo extends WarpElement {
    declare links: Array<PopularSearchLink>;

    static styles = [
        WarpElement.styles,
        css`
            @css-placeholder-XFpsQ5;
        `,
    ];

    static properties = {
        links: { type: Array },
    };

    constructor() {
        super();
    }

    connectedCallback() {
        activateI18n();
        super.connectedCallback();
    }

    render() {
        return html`
            <div class="flex">
                <div class="max-w-[1024] flex flex-col gap-16 w-full">
                    <h3 class="t3">
                        ${i18n.t({
                            id: "seo.title",
                            message: "Popular searches",
                        })}
                    </h3>
                    <ul class="grid grid-cols-5 lt-md:grid-cols-2 gap-x-56 gap-y-4">
                        ${this.links.map(
                            (link) => html`
                                <li>
                                    <a href="${link.url}" class="s-text s-text-subtle block truncate"> ${link.label} </a>
                                </li>
                            `,
                        )}
                    </ul>
                </div>
            </div>
        `;
    }
}

customElements.define("popular-links-for-seo", PopularLinksForSeo as unknown as CustomElementConstructor);
